module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAANUlEQVQ4y2NgGBwgeOl/ZPz/HMP/SwImYBpdDgUPIwNACtExzAB8GG4ASDE5mHouGI3GoQ4AezhUaON8Wi8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AX.png
// module id = 1082
// module chunks = 0